import { TRANSITION_CLASSNAME_MAP } from "./chunk-QYNQXSV2.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Transition/Transition.Child.tsx
import { Transition as HeadlessUiTransition } from "@headlessui/react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var TransitionChild = _a => {
  var _b = _a,
    {
      as: asProp,
      variant,
      duration = "md",
      enter,
      enterFrom,
      enterTo,
      leave,
      leaveFrom,
      leaveTo
    } = _b,
    rest = __objRest(_b, ["as", "variant", "duration", "enter", "enterFrom", "enterTo", "leave", "leaveFrom", "leaveTo"]);
  if (!variant) {
    return /* @__PURE__ */jsx(HeadlessUiTransition.Child, __spreadProps(__spreadValues({}, rest), {
      as: asProp || "div",
      enter,
      enterFrom,
      enterTo,
      leave,
      leaveFrom,
      leaveTo
    }));
  }
  return /* @__PURE__ */jsx(HeadlessUiTransition.Child, __spreadProps(__spreadValues({}, rest), {
    as: asProp || "div",
    enter: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].enter, TRANSITION_CLASSNAME_MAP.duration[duration].enter, enter),
    enterFrom: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].enterFrom, enterFrom),
    enterTo: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].enterTo, enterTo),
    leave: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].leave, TRANSITION_CLASSNAME_MAP.duration[duration].leave, leave),
    leaveFrom: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].leaveFrom, leaveFrom),
    leaveTo: clsx(TRANSITION_CLASSNAME_MAP.variant[variant].leaveTo, leaveTo)
  }));
};
var Transition_Child_default = TransitionChild;
export { Transition_Child_default };